import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Auth Store
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      refreshToken: null,
      settings: null,
      setAuth: (user, token, refreshToken) => set({ user, token, refreshToken }),
      setSettings: (settings) => set({ settings }),
      logout: () => set({ user: null, token: null, refreshToken: null }),
    }),
    { name: 'erp-auth', partialize: (s) => ({ user: s.user, token: s.token, refreshToken: s.refreshToken }) }
  )
)

// UI Store
export const useUIStore = create((set) => ({
  sidebarOpen: true,
  alerts: [],
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setAlerts: (alerts) => set({ alerts }),
}))
